<template>
  <b-row class="no-print" v-if="(disabled && documents && documents.length > 0) || !disabled">
    <b-col md="12" class="mt-3 text-muted pointer" @click="showUpload = !showUpload">
      {{ $t("attachments") }}
      <i v-if="!disabled && !showUpload" class="fa fa-angle-down"></i>
    </b-col>
    <b-col md="12" v-if="!disabled && showUpload">
      <pw-file-upload
        @upload="addDocument"
        :disabled="disabled"
        :anonymousUpload="$props.anonymousUpload"
        :isPublic="isPublic"
      ></pw-file-upload>
    </b-col>
    <i class="fa-solid fa-circle-xmark"></i>
    <i class="fa fa-times-circle-o" aria-hidden="true"></i>
    <b-container fluid class="p-4" v-if="documents.length > 0">
      <b-row class="p-1 img-gallery" align-v="end">
        <b-col md="12" class="p-1 mb-2 tile text-center" v-for="(document, index) in imgDocs" :key="index">
          <b-row>
            <b-col md="12">
              <b-img
                @click="openModal(document)"
                v-if="getFileThumbSource(document) == 'img'"
                class="doc-thumb"
                thumbnail
                fluid
                center
                :src="document.filepath"
                alt="Image 1"
              ></b-img>
            </b-col>
            <b-col md="12">
              <div class="ml-1 doc-title">
                <span @click="openModal(document)" class="mr-2">{{ document.name }}</span>
                <pw-button
                  v-if="!disabled"
                  md="1"
                  class="mr-2 text-center mt-3"
                  icon="fa-trash"
                  class-name="danger"
                  size="sm"
                  :require-confirm="true"
                  @accepted="removeDocument(document)"
                ></pw-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr v-if="imgDocs.length > 0 && docs.length > 0" />
      <b-row class="p-1 doc-gallery">
        <b-col md="12" class="p-1 mb-2 tile text-center" v-for="(document, index) in docs" :key="index">
          <b-row>
            <b-col md="12">
              <b-img
                @click="openModal(document)"
                v-if="getFileThumbSource(document) == 'img'"
                class="doc-thumb"
                thumbnail
                fluid
                :src="document.filepath"
                alt="Image 1"
              ></b-img>
              <div @click="openModal(document)" v-if="getFileThumbSource(document) == 'pdf'">
                <i class="doc-thumb thumb-fa fa fa-file-pdf" aria-hidden="true"></i>
              </div>
              <div @click="openModal(document)" v-if="getFileThumbSource(document) == 'doc'">
                <i class="doc-thumb thumb-fa fa fa-file-word" aria-hidden="true"></i>
              </div>
              <div @click="openModal(document)" v-if="getFileThumbSource(document) == 'xlsx'">
                <i class="doc-thumb thumb-fa fa fa-file-excel" aria-hidden="true"></i>
              </div>
              <div @click="openModal(document)" v-if="getFileThumbSource(document) == 'pptx'">
                <i class="doc-thumb thumb-fa fa fa-file-powerpoint" aria-hidden="true"></i>
              </div>
              <div @click="openModal(document)" v-if="getFileThumbSource(document) == 'unknown'">
                <i class="doc-thumb thumb-fa fa fa-file" aria-hidden="true"></i>
              </div>
            </b-col>
            <b-col md="12">
              <div class="ml-1 doc-title">
                <span class="mx-2" @click="openModal(document)">{{ document.name }}</span>
                <pw-button
                  v-if="!disabled"
                  class="mr-2 text-center mt-3"
                  icon="fa-trash"
                  class-name="danger"
                  size="sm"
                  :require-confirm="true"
                  @accepted="removeDocument(document)"
                ></pw-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      :visible="showDocModal"
      centered
      :hide-header-close="false"
      :hide-footer="false"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      size="xl"
      ok-only
      ok-variant="secondary"
      :ok-title="$t('cancel')"
      @close="closeModal()"
      @ok="closeModal()"
      style="width: 90vw; height: 90vh;"
    >
    <div class="mb-2" style="display: flex; justify-content: flex-end;">
      <b-button @click="openInNewTab(fileUrl)" v-b-tooltip.hover :title="$tc('openLinkInNewTab')">
        <i class="fas fa-external-link-alt"></i>
      </b-button>
    </div>
      <b-embed
        type="iframe"
        :src="fileUrl"
        v-if="isPdf"
        allowfullscreen
        style="width: 100%; height: 80vh; border: none;"
      ></b-embed>
      <!-- <b-embed
        type="iframe"
        :src="fileBlob"
        v-if="isPdf"
        allowfullscreen
        style="width: 100%; height: 80vh; border: none;"
      ></b-embed> -->
      <img v-if="isImg" class="image-preview" :src="fileUrl" />
    </b-modal>
    <iframe class="doc-preview" :src="fileUrl" v-show="false" v-if="fileUrl != ''" />
  </b-row>
</template>

<script>
import PwFileUpload from "@/components/PwFileUpload.vue";
import DocumentService from "@/services/DocumentService";
import { Browser } from '@capacitor/browser';
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

export default {
  name: "DocumentList",
  components: { PwFileUpload },
  props: {
    documents: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    anonymousUpload: {
      type: Boolean
    },
    isPublic: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showDocModal: false,
      fileBlob: "",
      fileUrl: "",
      imgDocs: [],
      docs: [],
      isPdf: false,
      isImg: false,
      isDoc: false,
      showUpload: false
    };
  },
  mounted() {
    this.filterDocs();
  },
  watch: {
    documents(documents) {
      this.documents = documents;
      this.filterDocs();
    }
  },
  methods: {
    // Hjälpfunktion: Konvertera Blob till Base64
    convertBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = reject;
          reader.onload = () => resolve(reader.result.split(',')[1]); // Rensa bort metadata (t.ex. "data:application/pdf;base64,")
          reader.readAsDataURL(blob);
      });
    },
    openInNewTab(url){

      if( Capacitor.isNativePlatform()){
        Browser.open({ url: url });
      }
      else{
        window.open(url, '_blank');
      }
    },
    addDocument(document) {
      this.documents.push(document);
    },
    removeDocument(document) {
      let index = this.documents.findIndex((d) => d.id === document.id);
      this.documents.splice(index, 1);
      this.filterDocs();
    },
    getFileThumbSource(document) {
      let fileExtension = document.name.replace(/^.*\./, "");
      switch (fileExtension.toLowerCase()) {
        case "pdf":
          document.thumbSource = "pdf";
          break;
        case "doc":
        case "docx":
        case "dotx":
          document.thumbSource = "doc";
          break;
        case "xlsx":
        case "xls":
        case "xlsm":
        case "xlsb":
        case "xltx":
        case "xltm":
          document.thumbSource = "xlsx";
          break;
        case "ppt":
        case "pptx":
          document.thumbSource = "pptx";
          break;
        case "png":
        case "jpeg":
        case "jpg":
          document.thumbSource = "img";
          break;
        default:
          document.thumbSource = "unkown";
          break;
      }
      return document.thumbSource;
    },
    closeModal() {
      this.showDocModal = false;
    },
    openModal(document) {
      this.isPdf = false;
      this.isImage = false;
      this.fileUrl = document.filepath;
      this.fileBlob = "";
      
      if (document.thumbSource == "pdf") {
        this.isPdf = true;

        if(Capacitor.getPlatform() == 'android'){
          window.open(this.fileUrl, '_system');
        }
        else{
          this.showDocModal = true;
          DocumentService.getDocumentArrayBuffer(document.filepath).then(res => {
            var file = new Blob([res], { type: "application/pdf" });
            var fileContent = URL.createObjectURL(file);
            this.fileBlob = fileContent;
            this.isPdf = true;
            this.showDocModal = true;
          });
        }
      } else if (document.thumbSource == "img") {
        this.showDocModal = true;
        this.isImg = true;
      } else {

      }
    },
    filterDocs() {
      this.imgDocs = [];
      this.docs = [];
      this.documents.map((item) => {
        let fileExtension = item.name.replace(/^.*\./, "").toLowerCase();
        if (fileExtension == "png" || fileExtension == "jpeg" || fileExtension == "jpg") {
          this.imgDocs.push(item);
        } else {
          this.docs.push(item);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.doc-gallery .thumb-fa {
  font-size: 50px;
  border: 1px solid #e9ecef;
  border-radius: 0.3rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}
.doc-gallery .tile,
.img-gallery .tile {
  cursor: pointer;
}
.doc-gallery .doc-thumb:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  transition: all 0.3s ease;
}
.img-gallery .doc-thumb:hover {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
  transition: all 0.3s ease;
}
.doc-gallery .fa-file-pdf {
  color: #b22727;
}
.doc-gallery .fa-file-word {
  color: #006e7f;
}
.doc-gallery .fa-file-excel {
  color: #1d6f42;
}
.doc-gallery .fa-file {
  color: #81b29a;
}
.doc-gallery .fa-file-powerpoint {
  color: #b22727;
}
.doc-gallery .btn[cy-id="pw-button"] {
  font-size: 0;
  margin-left: 5px;
}
.doc-gallery .btn .fa {
  font-size: 7px;
}
.doc-gallery img {
  max-width: 50px;
  max-height: 50px;
  width: auto;
  height: auto;
}
.img-gallery img {
  max-width: 150px;
  max-height: 150px;
}
.doc-gallery .doc-title span {
  font-size: 13px;
  word-break: break-all;
}
.image-preview {
  width: 100%;
  width: 100%;
}
.doc-preview {
  visibility: hidden;
}
</style>
